module.exports = __webpack_public_path__ + "img/icon-startup-light-old.bcff23cf.svg";